import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const PictureStatusIcon = withLiteObserverAndTheme<{ statusImage: string }>(
  (props) => {
    const { statusImage } = props;
    switch (statusImage) {
      case "accepted-logo":
        return <CheckCircleIcon color="success" />;
      case "rejected-logo":
        return <CancelIcon color="error" />;
      case "pending-logo":
        return <ScheduleIcon color="warning" />;
      default:
        return <DeleteOutlineIcon color="disabled" />;
    }
  }
);

export default PictureStatusIcon;
